module.exports = __webpack_public_path__ + "static/img/14000785.3b3c19c2.png";